import Accordion from 'accordion/src/accordion.mjs';

const CLASSNAME_ENABLED = 'accordion--enabled';

class DefaultAccordion {
  constructor(options = {}) {
    this.element = options.element;
    this.heightOffset = this.element.dataset.heightOffset || null;
    this.withMedia = this.element.dataset.withMedia || false;
    this.classNameContent = this.element.dataset.classNameContent || 'org--accordion__content';
  }

  init() {
    // accordion items containing images or videos require a timeout to accurately calculate their height
    if (this.withMedia) {
      window.setTimeout(() => this.createAccordion(), 1000);
    } else {
      this.createAccordion();
    }
  }

  createAccordion() {
    const content = this.element.querySelector(`.${this.classNameContent}`);

    // eslint-disable-next-line no-new
    new Accordion(content, {
      enabledClass: CLASSNAME_ENABLED,
      modal: true,
      noAria: false,
      heightOffset: this.heightOffset,
    });
  }
}

export default DefaultAccordion;
